export const TREND_STATUS = {
	FALLING: "QUEDA",
	GROWING: "CRESCIMENTO"
};

export const isFallingTrend = trend => {
	return String(trend || "").toUpperCase() === TREND_STATUS.FALLING;
};

export const hasTrend = trend => {
	return Boolean(String(trend || "").trim());
};

export const getTrendLabel = trend => {
	return isFallingTrend(trend) ? "(Em queda)" : "(Em crescimento)";
};

export const getTrendClassName = trend => {
	return [
		"dashboard-sales-summary__status",
		isFallingTrend(trend)
			? "dashboard-sales-summary__status--down"
			: "dashboard-sales-summary__status--up"
	].join(" ");
};